import React, { useMemo, useState } from "react";
import Card from "components/card";
import axios from "../../../../api/axios";
import { useNavigate } from "react-router-dom";

import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

const CheckTableDashboard = ({ columnsData, tableData, redirectPath }) => {
  const [ setShowModal] = useState(false);
  const [ setSelectedReport] = useState(null);

  const navigate = useNavigate();

  // Replace "Emri i raportuesit" with "Nr i raportit"
  const columns = useMemo(() => {
    return columnsData
      .map((col) => {
        if (col.Header === "Emri i raportuesit") {
          return { ...col, Header: "Nr i raportit", accessor: "reportName" };
        }
        return col;
      })
      .filter((col) => col.Header !== "Email adresa"); // remove email
  }, [columnsData]);

  const data = useMemo(() => {
    // Reverse data so newest first
    return [...tableData].reverse();
  }, [tableData]);

  const handleRedirect = () => {
    if (redirectPath) {
      navigate(redirectPath);
    }
  };

  // const fetchReportDetails = async (reportId) => {
  //   const storedToken = localStorage.getItem("token");
  //   const token = "Bearer " + storedToken.replace(/"/g, "");
  //   const headers = {
  //     Authorization: token,
  //     "Content-Type": "application/json",
  //   };

  //   try {
  //     const response = await axios.get(`/api/reports/report/${reportId}`, {
  //       headers,
  //     });
  //     setSelectedReport(response.data);
  //     setShowModal(true);
  //   } catch (error) {
  //     console.error("Error fetching report details:", error);
  //   }
  // };

  const tableInstance = useTable(
    { columns, data },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow, initialState } = tableInstance;
  initialState.pageSize = 11;

  return (
    <Card extra={"w-full sm:overflow-auto p-4"}>
      <header className="relative flex lg:px-2 items-center justify-between">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          {tableData.length <= 5 ? "Lista e raporteve të reja" : "Lista e raporteve të reja"}
        </div>
        <button
          className="text-sm font-medium text-brand-500 hover:text-brand-700"
          onClick={handleRedirect}
        >
          Shiko të gjitha
        </button>
      </header>

      <div className="mt-8 w-full overflow-x-scroll xl:overflow-x-hidden">
        {tableData.length === 0 ? (
          <div className="text-center py-6 text-gray-600 dark:text-gray-300">
            Nuk keni raporte të reja
          </div>
        ) : (
          <table {...getTableProps()} className="w-full" variant="simple" color="gray-500" mb="24px">
            <thead>
              {headerGroups.map((headerGroup, index) => (
                <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                  {headerGroup.headers.map((column, index) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className="border-b border-gray-200 pb-[10px] pr-16 text-start dark:!border-navy-700"
                      key={index}
                    >
                      <div className="text-xs font-bold tracking-wide text-gray-600 lg:text-xs">
                        {column.render("Header")}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, index) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={index}>
                    {row.cells.map((cell, index) => {
                      let cellData = "";

                      if (cell.column.Header === "Nr i raportit") {
                        cellData = <p className="text-sm font-bold text-navy-700 dark:text-white">{cell.value}</p>;
                      } else if (cell.column.Header === "Kategoria" || cell.column.Header === "Lokacioni") {
                        cellData = <p className="text-sm font-bold text-navy-700 dark:text-white">{cell.value}</p>;
                      } else if (cell.column.Header === "Data dhe ora") {
                        const date = new Date(cell.value);
                        const formattedDate = `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
                          .toString()
                          .padStart(2, "0")}/${date.getFullYear()} ${date.getHours().toString().padStart(2, "0")}:${date
                          .getMinutes()
                          .toString()
                          .padStart(2, "0")}`;
                        cellData = <p className="text-sm font-bold text-navy-700 dark:text-white">{formattedDate}</p>;
                      }

                      return (
                        <td {...cell.getCellProps()} key={index} className="pb-[16px] pt-[14px] sm:text-[14px]">
                          {cellData}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </Card>
  );
};

export default CheckTableDashboard;
